"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMavenPackageInfo = void 0;
const tslib_1 = require("tslib");
const packageurl_js_1 = require("packageurl-js");
const debugLib = require("debug");
const path = require("path");
const debug = debugLib('snyk-mvn-plugin');
const PACKAGE_SEARCH_TYPE = 'maven';
const PACKAGE_SEARCH_ENDPOINT = '/packages';
const PACKAGE_SEARCH_VERSION = '2022-09-21~beta';
function getMavenPackageInfo(sha1, targetPath, snykHttpClient) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const searchResults = yield searchMavenPackageByChecksum(sha1, targetPath, snykHttpClient);
        if (searchResults.length == 0) {
            return fallbackPackageInfo(sha1, targetPath);
        }
        let foundPackage;
        if (searchResults.length > 1) {
            const sha1Target = path.parse(targetPath).base;
            debug(`Got multiple results for ${sha1}, looking for ${sha1Target}`);
            foundPackage = searchResults.find((result) => sha1Target.includes(result.groupId));
        }
        return foundPackage || searchResults[0];
    });
}
exports.getMavenPackageInfo = getMavenPackageInfo;
function searchMavenPackageByChecksum(sha1, targetPath, snykHttpClient) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { res, body } = yield snykHttpClient({
            method: 'get',
            path: PACKAGE_SEARCH_ENDPOINT,
            qs: {
                version: PACKAGE_SEARCH_VERSION,
                package_type: PACKAGE_SEARCH_TYPE,
                package_sha1: sha1,
            },
        });
        if (!(res === null || res === void 0 ? void 0 : res.statusCode) || (res === null || res === void 0 ? void 0 : res.statusCode) >= 400 || !body) {
            debug(`Failed to resolve ${targetPath} using sha1 ${sha1}.`);
            return [];
        }
        return mapPackageSearchResult(body, sha1, targetPath);
    });
}
function mapPackageSearchResult(body, sha1, targetPath) {
    return body.data
        .map((purl) => {
        try {
            const pkg = packageurl_js_1.PackageURL.fromString(purl.id);
            const fallback = fallbackPackageInfo(sha1, targetPath);
            return {
                groupId: pkg.namespace || fallback.groupId,
                artifactId: pkg.name || fallback.artifactId,
                version: pkg.version || fallback.version,
            };
        }
        catch (_error) {
            debug(`Failed to parse package url components for ${targetPath} using sha1 '${sha1}.`);
            return undefined;
        }
    })
        .filter((mvnPackage) => mvnPackage !== undefined);
}
function fallbackPackageInfo(sha1, targetPath) {
    return {
        groupId: 'unknown',
        artifactId: `${targetPath}:${sha1}`,
        version: 'unknown',
    };
}
//# sourceMappingURL=search.js.map